import '@babel/polyfill'
import Vue from 'vue'
import router from './router'
import VueResource from 'vue-resource'
//_____________________________________________________________________________

import './plugins/vuetify'
Vue.config.productionTip = true
//_____________________________________________________________________________
Vue.use(VueResource)
//_____________________________________________________________________________
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
//_____________________________________________________________________________
import numeral from 'numeral'

numeral.register('locale', 'de', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'Tsd',
    million: 'Mil',
    billion: 'Mrd',
    trillion: 'Bil'
  },
  ordinal: function (number) {
    return number === 1 ? 'ster' : 'ter'
  },
  currency: {
    symbol: '€'
  }
})

numeral.locale('de')

const myNumeral = {
  install (Vue, options) {
    Vue.prototype.$numeral = numeral
    Vue.$numeral = Vue.prototype.$numeral
  }
}
Vue.use(myNumeral)
//_____________________________________________________________________________
//Register Vuex into Vue:
import Vuex from 'vuex'
import storeDefinition from './store'

Vue.use(Vuex)

const store = new Vuex.Store(storeDefinition)
window.store = store
//_____________________________________________________________________________
import Moment from 'moment-mini'

window.moment = Moment

Vue.filter('date_DB_de', function (dateString) {

  if (!dateString) {
    return null
  }
  if (dateString === '00.00.0000') {
    return null
  }
  if (dateString === '0000-00-00') {
    return null
  }
  var _sourceDelimiter = '-'
  var _targetDelimiter = '.'
  var dateItems = dateString.split(_sourceDelimiter)
  var targetDateString = dateItems[2] + _targetDelimiter + dateItems[1] + _targetDelimiter + dateItems[0]
  console.log('targetDateString', targetDateString)
  return targetDateString
})
Vue.filter('date_de_DB', function (dateString) {

  if (!dateString) {
    return null
  }
  if (dateString === '0000-00-00') {
    return null
  }
  if (dateString === '00.00.0000') {
    return null
  }
  var _sourceDelimiter = '.'
  var _targetDelimiter = '-'
  var dateItems = dateString.split(_sourceDelimiter)
  var targetDateString = dateItems[2] + _targetDelimiter + dateItems[1] + _targetDelimiter + dateItems[0]
  console.log('targetDateString', targetDateString)
  return targetDateString
})
Vue.filter('number_DB_de', function (number) {

  if (!number) {
    return null
  }
  var numberString = number + ''
  console.log('targetNumberString a', numberString)
  var targetNumberString = numberString.replace(/,/g, '')
  console.log('targetNumberString b', targetNumberString)
  targetNumberString = targetNumberString.replace(/\./g, ',')
  console.log('targetNumberString c', targetNumberString)
  if (targetNumberString.substr(targetNumberString.length - 2, 1) === ',') {
    targetNumberString = targetNumberString + '0'
  }
  if (targetNumberString.indexOf(',') === -1) {
    targetNumberString = targetNumberString + ',00'
  }

  console.log('targetNumberString', targetNumberString)
  return targetNumberString
})
Vue.filter('number_de_DB', function (number) {

  if (!number) {
    return null
  }
  console.log('targetNumberString a', number)
  var numberString = number + ''
  var targetNumberString = numberString.replace(/\./g, '')
  targetNumberString = targetNumberString.replace(/,/g, '.')
  var targetNumber = parseFloat(targetNumberString)
  console.log('targetNumberString e', targetNumberString)
  return targetNumber
})

Vue.filter('number_DB_currency_de', function (number) {
  //console.log("???????????????????????????????number", number);
  if (!number) {
    return null
  }
  var i = parseFloat(number)
  if (isNaN(i)) {
    i = 0.00
  }
  var minus = ''
  if (i < 0) {
    minus = '-'
  }
  i = Math.abs(i)
  i = parseInt((i + 0.005) * 100)
  i = i / 100
  //console.log("i", i);
  var s = i + ''
  if (s.indexOf('.') < 0) {
    s += '.00'
  }
  if (s.indexOf('.') === (s.length - 2)) {
    s += '0'
  }
  s = minus + s
  //console.log("s", s);

  s = s.replace('.', ',')
  return s
})
//_____________________________________________________________________________
/* eslint-disable */
import hostinfo from '../../hostinfo'
/* eslint-enable */

console.log('dev_api_server: ', hostinfo.dev_api_server)
console.log('dev_machine: ', hostinfo.dev_machine)
console.log('eviroment: ', process.env.NODE_ENV)

/*
if (process.env.NODE_ENV === "development") {
  store.commit('session_setApiServer', {url: 'http://' + hostinfo.dev_server_backend + '/api-request.php'});

} else {
  store.commit('session_setApiServer', {url: 'http://' + hostinfo.prod_server_backend + '/api-request.php'});

}
*/

/*
if (process.env.NODE_ENV === "development") {
  store.commit('session_setApiServer', {url: 'http://' + hostinfo.dev_api_server + '/api-request.php'});

} else {
  store.commit('session_setApiServer', {url: '/api-request-include.php'});

}
*/

// im Dev und Prod kann jetzt immer die selber URL genommen werden
// (dank der  Lösung bei Dev mit ProxyPass im apache vHost-Config)
//  so wird jetzt alles (bis auf der api-request) von localhost:8080 (apache) auf localhost:808x (vue-dev-server) geleitet
// somit läuft vue Frontend und phpBackend auf 'sameOrigin' :-)
store.commit('session_setApiServer', {url: '/api-facade/api-request'})

console.log('store.state.session.api_url', store.state.session.api_url)
//_______________________________________________________________________________________________

import App from './components/App.vue'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
